export default class Slider {
  constructor(slider, controls) {
    this.position = 0;
    this.slidesToShow = controls.slides.slidesToShow;
    this.slidesToScroll = controls.slides.slidesToScroll;
    this.slider = document.querySelector(slider);
    this.track = this.slider.querySelector(controls.track);
    this.prev = this.slider.querySelector(controls.buttons.prev);
    this.next = this.slider.querySelector(controls.buttons.next);
    this.slides = this.slider.querySelectorAll(controls.slide);
    this.slidesCount = this.track.children.length;
    this.slideWidth = this.track.clientWidth / this.slidesToShow;
    this.movePosition = this.slidesToScroll * this.slideWidth;
    this.checkButtonState();
    this.setNextSlide();
    this.setPrevSlide();
    this.setWidth();
  }

  setWidth() {
    this.slides.forEach(slide => {
      slide.style.minWidth = `${this.slideWidth}px`;
    });
  }

  _nextSlide() {
    const slidesLeft =
      this.slidesCount -
      (Math.abs(this.position) + this.slidesToShow * this.slideWidth) /
        this.slideWidth;
    this.position -=
      slidesLeft >= this.slidesToScroll
        ? this.movePosition
        : slidesLeft * this.slideWidth;
    this.setPosition();
    this.checkButtonState();
  }

  _prevSlide() {
    const slidesLeft = Math.abs(this.position) / this.slideWidth;
    this.position +=
      slidesLeft >= this.slidesToScroll
        ? this.movePosition
        : slidesLeft * this.slideWidth;
    this.setPosition();
    this.checkButtonState();
  }

  setNextSlide() {
    this.next.addEventListener("click", () => this._nextSlide());
  }

  setPrevSlide() {
    this.prev.addEventListener("click", () => this._prevSlide());
  }

  setPosition() {
    this.track.style.transform = `translateX(${this.position}px)`;
  }

  checkButtonState() {
    this.prev.disabled = this.position === 0;
    this.next.disabled =
      this.position <=
      -(this.slidesCount - this.slidesToShow) * this.slideWidth;
  }

  destroy() {
    this.next.removeEventListener("click", () => this._nextSlide());
    this.prev.removeEventListener("click", () => this._prevSlide());
    this.slider = this.track = this.prev = this.next = this.slides = this.slidesCount = this.slideWidth = this.movePosition = null;
  }
}
